import axios from 'axios'

export default {
  updates (entity, data) {
    axios.post('/api/v2/' + entity + '/update-positions', {
      data: data
    })
  },
}
